<template>
  <select
    v-model="value"
    :class="`block w-full text-xs py-1 px-3 border border-gray-200 rounded   font bg-white
     focus:outline-none focus:ring-0 ring-0
      hover:border-gray-400 transition-colors duration-200 focus:border-indigo-500
      ${loading ? 'cursor-wait opacity-75' : ''}
     ` "
  >
    <option
      v-if="!(initialValue in options)"
      :value="initialValue"
      disabled
      selected
    >
      {{ $t(options[initialValue]) || 'Select an option' }}
    </option>
    <option
      v-for="(label, v) in options"
      :key="v"
      :value="v"
      class="py-1"
    >
      {{ $t(label) }}
    </option>
  </select>
</template>

<script>

import api from '@/api';

export default {
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      default: 'POST',
    },
    field: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    initialValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: this.initialValue,
      success: false,
      successTimeout: null,
      loading: false,
    };
  },
  watch: {
    value() {
      this.send();
    },
  },
  methods: {
    async send() {
      this.loading = true;

      try {
        await api.request({
          url: this.endpoint,
          method: this.method,
          data: {
            [this.field]: this.value,
          },

        });
        this.success = true;
        clearTimeout(this.successTimeout);
        this.successTimeout = setTimeout(() => {
          this.success = false;
        }, 2000);}

      catch (error) {
        console.error('Error sending request:', error);
        this.loading = false;
        return;
      }
      this.loading = false;
    },
  },
};

</script>
